import React from 'react';
import logofooter from '../../resource/img/logofooter.svg'
import appstore from '../../resource/img/appstore.svg'
import googleplay from '../../resource/img/googleplay.svg'

const Footer = ({mostrarModal, pageActivo, pageLogin}) => 
(
<>
    { pageLogin ?
    <>
        <footer className="mb-display-none display-flex footerLogin flex-column align-items-center justify-content-center">
            <p><span className="pointer" onClick={()=> mostrarModal('condiciones',null)} >Términos y condiciones -</span> Rimac Seguros y Reaseguros. Todos los derechos reservados.</p>
        </footer>
        <footer className="mb-display-flex display-none footerLogin footerActive mb-d-flex mb-flex-column mb-justify-content-center mb-align-items-start">
            <p> &copy; 2019 Rimac Seguros y Reaseguros.</p>
            <p> Todos los derechos reservados.</p>
        </footer>
    </> : null }

    { pageActivo ? 
        <footer className="footerActive d-flex mb-footer">
            <div className="container footerActive-body d-flex align-items-center justify-content-between">
                <div className="footerActive-body-info d-flex">
                    <img src={logofooter} alt=""/>
                    <p> &copy; 2019 Rimac Seguros y Reaseguros.</p>
                    <p> Todos los derechos reservados.</p>
                </div>
                <div className="footerActive-body-store d-flex">
                    <a className="d-flex align-items-center"><img src={appstore} alt=""/>App Store</a>
                    <a className="d-flex align-items-center"><img src={googleplay} alt=""/>Google Play</a>
                </div>
                
            </div>
        </footer>
        : null }
</>
)
    


export default Footer;